import './style.scss'

import React, { PureComponent } from 'react'

import Icon from 'components/UI/Icon'
import PropTypes from 'prop-types'
import chevron from 'img/chevron.svg'
import classNames from 'classnames'
import { withTranslation } from 'react-i18next'

class CartCounter extends PureComponent {
    render() {
        const { value, title, onIncrease, onDecrease, t, view } = this.props
        const classes = classNames('cart-counter', {
            [`cart-counter--${view}`]: view,
        })

        const increaseProduct = {
            title: title,
            count: value + 1,
        }
        const decreaseProduct = {
            title: title,
            count: value - 1,
        }

        return (
            <div className={classes}>
                <button
                    className="cart-counter__button cart-counter__button--increase"
                    aria-label={t('productBuyCount', increaseProduct)}
                    onClick={() => {
                        onIncrease()
                    }}
                >
                    <Icon svg={chevron} />
                </button>
                <input value={value} tabIndex="-1" readOnly />
                <button
                    className="cart-counter__button cart-counter__button--decrease"
                    aria-label={t('productBuyCount', decreaseProduct)}
                    onClick={() => {
                        onDecrease()
                    }}
                >
                    <Icon svg={chevron} />
                </button>
            </div>
        )
    }
}

CartCounter.propTypes = {
    view: PropTypes.string,
    value: PropTypes.number.isRequired,
    title: PropTypes.string,
    onIncrease: PropTypes.func.isRequired,
    onDecrease: PropTypes.func.isRequired,
    t: PropTypes.func,
}

export default withTranslation()(CartCounter)
